import React from 'react'

interface Props {
  children?: React.ReactNode
}

export const ComponentToPrint = React.forwardRef<HTMLDivElement, Props>(
  ({children}: Props, ref) => <div ref={ref}>{children}</div>,
)
